var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 6.24089H11.3346V4.90755C11.3346 3.06755 9.8413 1.57422 8.0013 1.57422C6.1613 1.57422 4.66797 3.06755 4.66797 4.90755V6.24089H4.0013C3.26797 6.24089 2.66797 6.84089 2.66797 7.57422V14.2409C2.66797 14.9742 3.26797 15.5742 4.0013 15.5742H12.0013C12.7346 15.5742 13.3346 14.9742 13.3346 14.2409V7.57422C13.3346 6.84089 12.7346 6.24089 12.0013 6.24089ZM8.0013 12.2409C7.26797 12.2409 6.66797 11.6409 6.66797 10.9076C6.66797 10.1742 7.26797 9.57422 8.0013 9.57422C8.73464 9.57422 9.33464 10.1742 9.33464 10.9076C9.33464 11.6409 8.73464 12.2409 8.0013 12.2409ZM10.068 6.24089H5.93463V4.90755C5.93463 3.76755 6.8613 2.84089 8.0013 2.84089C9.1413 2.84089 10.068 3.76755 10.068 4.90755V6.24089Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.b770b4c695076cfb9e3d6edd0aafb005.svg";
export { ForwardRef as ReactComponent };